import styled from "styled-components";

const Container = styled.div`
    height: 30px;
    width: 100vw;
    color: #fff;
    background-color: teal;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
`
const Announcement = () => {
  return (
    <Container>
        All the product you will get at cheapest price
    </Container>
  )
}

export default Announcement;